module.exports = __webpack_public_path__ + "static/media/pollopechugaconhueso.eaad9afb.jpg";